import { c as _c } from "react/compiler-runtime";
import React, { memo } from "react";
interface SectionProps {
  readonly title: string;
  readonly children: React.ReactNode;
  readonly className?: string;
}

/**
 * Base Section component
 * Renders a section of form fields with a title
 */
const SectionComponent: React.FC<SectionProps> = t0 => {
  const $ = _c(9);
  const {
    title,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="-tw-mt-2 tw-h-0.5 tw-w-8 tw-bg-gradient-to-r tw-from-iron-700 tw-to-transparent tw-rounded-full" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <h3 className="tw-text-sm tw-font-medium tw-text-iron-400 tw-uppercase tw-tracking-wider">{title}</h3>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="-tw-mt-2 tw-flex-1 tw-h-0.5 tw-bg-gradient-to-r tw-from-iron-800 tw-to-transparent tw-rounded-full" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div className="tw-flex tw-items-center tw-gap-3">{t1}{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== t4) {
    t5 = <div className="tw-space-y-5">{t4}{children}</div>;
    $[6] = children;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};

/**
 * Custom equality function for optimizing re-renders
 * Only re-renders when title or className changes
 */
const areSectionPropsEqual = (prevProps: SectionProps, nextProps: SectionProps): boolean => {
  return prevProps.title === nextProps.title && (prevProps.className ?? "") === (nextProps.className ?? "")
  // React handles children comparison internally
  ;
};

/**
 * Memoized Section component to prevent unnecessary re-renders
 */
export const Section = memo(SectionComponent, areSectionPropsEqual);
Section.displayName = "Section";